<template>
  <div class="dropdown" :class="isEditingApprove ? 'is-active' : ''">
    <div class="dropdown-trigger">
      <button class="button is-small" @click="toggleApproveEdit">
        <span>{{ approvedText }}</span>
      </button>
    </div>
    <div class="dropdown-menu" id="dropdown-menu-fd3f" role="menu">
      <div class="dropdown-content">
        <div class="dropdown-item">
          <div class="has-text-left mb-3 is-flex is-justify-content-space-between">
            <button class="delete" @click="isEditingApprove = false"></button>
            <span>Is approved</span>
          </div>
          <div class="buttons has-addons is-centered">
            <button class="button is-small" :class="{ 'is-warning': applicantJobTitle.is_approved === true }" @click="toggleIsApprove(true)">
              True
            </button>
            <button class="button is-small mx-1" :class="{ 'is-warning': applicantJobTitle.is_approved === false }" @click="toggleIsApprove(false)">
              False
            </button>
            <button class="button is-small is-danger" @click="toggleIsApprove(null)">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicantJobTitleIsApproved',
  props: {
    applicantId: {
      type: Number,
      required: true
    },
    applicantJobTitle: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isEditingApprove: false
    }
  },
  computed: {
    approvedText () {
      if (this.applicantJobTitle.is_approved === true) {
        return 'approved'
      }
      if (this.applicantJobTitle.is_approved === false) {
        return `rejected on ${this.$moment(this.applicantJobTitle.approval_date).format('DD/MM/YYYY')}`
      }
      return '?'
    }
  },
  methods: {
    toggleApproveEdit () {
      this.isEditingApprove = !this.isEditingApprove
    },
    async toggleIsApprove (value) {
      let action = value ? 'approve' : 'reject'
      let date = new Date()
      if (value === null) {
        action = 'cancel'
        date = null
      }
      await this.$network_utils.updateApplicantJobTitle({
        job_title_id: this.applicantJobTitle.id,
        applicant_id: this.applicantId,
        is_approved: value,
        approval_date: date
      })
      this.isEditingApprove = false
      this.$emit('updated', { action, jobTitle: this.applicantJobTitle })
    }
  }
}
</script>
